import { format } from "date-fns";

export default {
  methods: {
    formatDateTime: function(date) {
      if (date) {
        return format(new Date(date), "dd/MM/yyy HH:mm");
      }
    },
    formatTime: function(date) {
      if (date) {
        return format(new Date(date), "HH:mm");
      }
    }
  }
};
